<template>
  <div class="content">
    <div class="forms inputType">
      <!-- PERSONA FÍSICA -->
      <div
        class="p-fluid"
        v-if="
          persona.PersonaFisicaID !== 'Persona de Filiacion desconocida' &&
          persona.Apellido !== 'Orden público'
        "
      >
        <div class="grid flex">
          <div class="col-12 md:col-6">
            <div class="field col-12 md:col-12 sm:col-12 condition">
              <InputText
                v-model="persona.TipoRolPersonaFisicaID"
                optionLabel="nombre"
                class="lg:col-12 md:col-12 sm:col-12"
                disabled
              />
            </div>
          </div>
          <div class="field-checkbox col-12 md:col-6 justify-content-end">
            <label v-if="persona.DomicilioJuridico"> Es Persona Jurídica </label>
          </div>
        </div>
        <div class="p-fluid formgrid grid">
          <div class="grid w-full wrap">
            <div class="field col-2 md:col-2 sm:col-2" test-id="buttonTipoDocDenunciante">
              <label for="tipoDocumento">Tipo de doc. </label>
              <InputText dataKey="nombre" placeholder="DNI" disabled />
            </div>
            <div class="field col-2 md:col-2 sm:col-2">
              <label for="documento">N° de doc.</label>
              <InputText class="input" min="0" type="number" v-model="persona.Dni" disabled />
            </div>
            <div class="field col-1 md:col-1 sm:col-1" style="width: 190px">
              <label for="sexo">Sexo</label>
              <InputText v-model="persona.Sexo" placeholder="Sexo" disabled />
            </div>
            <div class="field col-3" style="width: 200px">
              <label for="exhibeDocumento">¿Exhibe el documento?</label>
              <InputText
                v-model="dataExhibeDocumento"
                placeholder="¿Exhibe el documento?"
                disabled
              />
            </div>
            <div class="field col-2 md:col-2 sm:col-2">
              <label for="cuil">N° de Cuil.</label>
              <InputText class="input" v-model="persona.Cuil" placeholder="N° de Cuil." disabled />
            </div>
          </div>
        </div>
        <div class="p-fluid formgrid grid">
          <div class="p-fluid formgrid grid">
            <div class="field col-12 md:col-5 sm:col-5" test-id="inputApellido">
              <label for="apellido">Apellido</label>
              <InputText
                class="input"
                type="text"
                placeholder="Apellido/s"
                v-model="persona.Apellido"
                disabled
              />
            </div>
            <div class="field col-12 md:col-5 sm:col-5" test-id="inputNombre">
              <label for="nombre">Nombre</label>
              <InputText
                class="input"
                type="text"
                placeholder="Nombre"
                v-model="persona.Nombre"
                disabled
              />
            </div>
            <div class="field col-12 md:col-2 sm:col-2" test-id="inputNombre">
              <label for="edad">Edad</label>
              <InputText
                class="input"
                type="text"
                placeholder="Edad"
                v-model="calcularEdad"
                disabled
              />
            </div>
            <div class="field col-12 md:col-4 lg:col-4 sm:col-6" test-id="inputFechaNac">
              <label for="fechaNacimiento">Fecha de nac.</label>
              <InputMask
                class="input"
                mask="99/99/9999"
                v-model="persona.FechaDeNacimiento"
                placeholder="dd/mm/yyyy"
                disabled
                slotChar="dd/mm/yyyy"
              />
            </div>
            <div class="field col-12 md:col-4 lg:col-4 sm:col-6" test-id="buttonNacionalidad">
              <label for="nacionalidad">Nacionalidad</label>
              <InputText v-model="persona.Nacionalidad" placeholder="Nacionalidad" disabled />
            </div>
            <div class="field col-12 md:col-4 lg:col-4" test-id="buttonEstadoCivil">
              <label for="estadoCivil">Estado civil</label>
              <InputText
                dataKey="nombre"
                class="input"
                v-model="persona.EstadoCivil"
                placeholder="Estado civil"
                disabled
              />
            </div>
            <div class="field col-12" test-id="textareaDomDeclarado">
              <label for="residenciaSIPE">Domicilio</label>
              <Textarea
                class="input"
                type="text"
                placeholder="Domicilio"
                v-model="persona.DomicilioSipe"
                disabled
              />
            </div>
            <div
              class="field col-12 lg:col-6 md:col-6 sm:col-6"
              v-if="persona.TipoRolPersonaFisicaID === 'Denunciante'"
            >
              <label for="vinculo">Vínculo con la víctima</label>
              <InputText
                class="input"
                type="text"
                placeholder="Vínculo con la víctima"
                v-model="persona.Vinculo"
                disabled
              />
            </div>

            <div class="p-fluid formgrid grid">
              <div :class="generateClasses()">
                <label for="telefono">Teléfono</label>
                <InputText
                  class="input"
                  type="number"
                  min="10000000"
                  max="999999999"
                  placeholder="Número de teléfono"
                  v-model="persona.Telefono"
                  disabled
                />
              </div>
              <div :class="generateClasses()">
                <label for="emailInput">Email</label>
                <InputText
                  class="input"
                  placeholder="Email"
                  v-model="persona.Email"
                  disabled
                  id="emailInput"
                />
              </div>
              <div :class="generateClasses()">
                <label for="profesion">Profesión</label>
                <InputText
                  class="input"
                  placeholder="Profesión"
                  v-model="persona.Profesion"
                  disabled
                />
              </div>
              <div :class="generateClasses()">
                <label for="tieneEstudios">¿Tiene estudios?</label>
                <InputText v-model="dataTieneEstudios" placeholder="¿Tiene estudios?" disabled />
              </div>
              <div :class="generateClasses()">
                <label for="instruccion">Instrucción</label>
                <InputText v-model="persona.Instruccion" placeholder="Instrucción" disabled />
              </div>
              <div class="field col-12">
                <label for="residencia">Observaciones</label>
                <Textarea
                  class="input"
                  type="text"
                  placeholder="Observaciones..."
                  v-model="persona.Observaciones"
                  disabled
                />
              </div>
            </div>
            <div class="field col-12 md:col-3 sm:col-6" v-if="acusado">
              <label for="nombre">Apodo</label>
              <InputText class="input" type="text" placeholder="apodo" v-model="persona.Apodo" />
            </div>
          </div>
        </div>

        <!-- FIN PERSONA FÍSICA -->
        <!-- PERSONA JURÍDICA -->
        <div class="p-fluid formgrid grid" v-if="persona.personaJuridica">
          <div class="field col-12">
            <h3>En representación de</h3>
          </div>
          <div class="field col-12 md:col-6">
            <label for="CUIT">CUIT</label>
            <InputText class="input" placeholder="CUIT" v-model="persona.Cuit" disabled />
          </div>
          <div class="field col-12 md:col-6">
            <label for="denominacion">Razón social</label>
            <InputText
              class="input"
              type="text"
              placeholder="Razón social"
              v-model="persona.Denominacion"
              disabled
            />
          </div>
          <div class="field col-12">
            <label for="domicilioJuridico">Domicilio legal</label>
            <InputText class="input" type="text" v-model="persona.DomicilioJuridico" disabled />
          </div>
          <div class="field col-12 lg:col-4 md:col-6 sm:col-6">
            <label for="telefono">Teléfono</label>
            <InputText
              class="input"
              type="text"
              placeholder="Teléfono"
              v-model="persona.TelefonoJuridico"
              disabled
            />
          </div>
          <div class="field col-12 lg:col-5 md:col-6 sm:col-6">
            <label for="rubro">Actividad</label>
            <InputText
              class="input"
              type="text"
              placeholder="Actividad"
              v-model="persona.Rubro"
              disabled
            />
          </div>
          <div class="field col-12 lg:col-3 md:col-6 sm:col-6 chkbx" test-id="divTieneSeguro">
            <Checkbox
              class="mr-2"
              id="tiene-seguro"
              v-model="persona.TieneSeguro"
              :binary="true"
              disabled
            />
            <label for="tiene-seguro" class="txtchkbx">Tiene seguro</label>
          </div>
        </div>
        <!-- FIN...   PERSONA JURÍDICA -->
      </div>
      <div
        v-else-if="persona.PersonaFisicaID === 'Persona de Filiacion desconocida'"
        class="flex justify-content-center"
      >
        <label class="text-xl">Persona de Filiación Desconocida</label>
      </div>
      <div v-else class="flex justify-content-center">
        <label class="text-xl">Orden público</label>
      </div>
    </div>
  </div>
</template>

<script>
import CustomAutoComplete from "@/components/custom-autocomplete/CustomAutoComplete.vue";
import Listbox from "primevue/listbox";
import ListBoxOptions from "@/components/ListBoxOptions/ListBoxOptions";
import InputMask from "primevue/inputmask";
import InputText from "primevue/inputtext/InputText";

export default {
  props: {
    acusado: Boolean,
    arrId: String,
    typeOfPerson: String,
    ordenPublico: Boolean,
    formType: String,
    persona: Object,
  },
  components: {
    CustomAutoComplete,
    Listbox,
    ListBoxOptions,
    InputMask,
  },
  name: "FormPersona",
  data() {
    return {};
  },
  watch: {},
  computed: {
    dataExhibeDocumento() {
      return this.persona.ExhibeDocumento === "1" ? "Si" : "No";
    },
    dataTieneEstudios() {
      return this.persona.TieneEstudios === "1" ? "Si" : "No";
    },
    calcularEdad() {
      if (!this.persona.FechaDeNacimiento) {
        return "Sin datos";
      }
      const [dia, mes, anio] = this.persona.FechaDeNacimiento.split(/[-/]/).map(Number);
      const fechaNacimientoDate = new Date(anio, mes - 1, dia);
      const fechaActual = new Date();

      let edad = fechaActual.getFullYear() - fechaNacimientoDate.getFullYear();
      const mesActual = fechaActual.getMonth();
      const diaActual = fechaActual.getDate();

      if (mesActual < mes - 1 || (mesActual === mes - 1 && diaActual < dia)) {
        edad--;
      }
      return edad;
    },
  },
  methods: {
    generateClasses() {
      let classes;
      if (this.persona.TipoRolPersonaFisicaID === "denunciante") {
        classes = "field col-12 md:col-2 lg:col-2 sm:col-2 w-13rem";
      } else {
        classes = "field col-12 md:col-4 lg:col-4 sm:col-4";
      }
      return classes;
    },
  },
};
</script>

<style scoped>
.spinner {
  display: none;
}
.input {
  resize: vertical;
  margin: 0;
}
.chkbx {
  display: flex;
  align-items: center;
  margin-top: 25px;
}
.txtchkbx {
  margin-top: 8px;
}
</style>
